import { outputTypeEnum } from "kubb";
import { FeatureAnnouncementBanner } from "../../../components/Banner";
import BetaAlert from "../../../components/Beta/BetaAlert";
import { PageHeadingBlock } from "../../../components/Theme/heading";
import { useCreateReportExecution } from "../../../hooks/createEntity";
import { useRequiredSelectedCompany } from "../../../reducers/company";
import { useSelectedScheme } from "../../../reducers/scheme";
import ReportExecutionCreator from "../executions/ReportExecutionCreator";
import ReportExecutionList from "../executions/ReportExecutionList";

function TimeSeriesDataExportPage() {
  const company = useRequiredSelectedCompany();
  const scheme = useSelectedScheme();

  const create = useCreateReportExecution(company.company_id);

  return (
    <>
      <PageHeadingBlock>Export Aggregated Data</PageHeadingBlock>
      <FeatureAnnouncementBanner
        featureId="2026-01-15-export-units"
        message="We've updated this feature to support units - it's been one of our most frequently requested features. By default we now will export energy in kWh and not Wh as before. You can switch back to Wh using the dropdown if you need it."
        margin={2}
      />
      <BetaAlert />
      <ReportExecutionCreator
        scheme={scheme}
        company={company}
        create={create.update}
        outputTypeFilter={[
          outputTypeEnum.AGGREGATED_DATA,
          outputTypeEnum.ALL_DATA,
        ]}
      />
      <PageHeadingBlock>Previous Executions</PageHeadingBlock>

      <ReportExecutionList
        company_id={company.company_id}
        scheme_id={scheme?.scheme_id}
        params={{
          format: [outputTypeEnum.AGGREGATED_DATA, outputTypeEnum.ALL_DATA],
        }}
        cursor={{ max_items: 15 }}
      />
    </>
  );
}

export default TimeSeriesDataExportPage;
